module.exports = __webpack_public_path__ + "static/media/ArchitectIcon.f6c2011e.svg";